import { useMemo } from 'react';

import { useClinicalNoteContext } from 'lib/context/ClinicalNoteContext/ClinicalNoteContext';
import { assignAdvTitlesToComponent } from 'lib/context/MyScribeAI/lib/getEnabledComponents';

import AdvancedForm from 'components/practice/charts/ClinicalNote/CurrentNote/TypeNotes/AdvancedForm/AdvancedForm';

import AIForm from '../AIForm';

const getFormsList = (customFormType, cnDisplaySettings, type) => {
  const formsList = {
    ...assignAdvTitlesToComponent({
      advancedList: customFormType,
      advancedComponent: AdvancedForm,
      cnDisplaySettings,
      withStyle: false,
      type
    })
  };
  return formsList;
};

const CustomForm = ({
  inputName,
  type,
  components,
  isScrolling,
  customCN = null,
  setCustomCN = null
}) => {
  const { customFormTypes, cnDisplaySettings } = useClinicalNoteContext();

  const customFormType = customFormTypes?.[type];

  const component = useMemo(() => {
    if (!inputName) return null;

    const advForms = getFormsList(customFormType, cnDisplaySettings, type);

    return advForms?.[inputName];
  }, [inputName, type]);

  return (
    <AIForm
      inputName={inputName}
      component={component}
      components={components}
      noteType={type}
      customCN={customCN}
      setCustomCN={setCustomCN}
      isScrolling={isScrolling}
    />
  );
};

export default CustomForm;
